import { ImpactModule } from 'types'
import { OBSERVATORY_PAGES } from './pages'
import { OBSERVATORY_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const OBSERVATORY_MODULE: ImpactModule = {
  NAME: 'dashboard',
  NAME_PTBR: 'Observatório',
  UPPER_NAME: 'DASHBOARD',
  API_NAME: 'DASHBOARD',
  PAGES: OBSERVATORY_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: OBSERVATORY_PAGES_ORDER_FOR_PERMISSIONS,
}
